import axios from 'axios';
// 导入表格生成工具
import { generateResultTable } from '../utils/TableGenerator.js';
// import { getCookie } from '@/utils'
export const uiInteractionMethods = {
  methods: {
    // 将电脑版招生章程URL转换为手机版URL
    convertToMobileUrl(url) {
      if (!url) return url;

      // 电脑版URL格式：/zsgs/zhangcheng/listZszc--schId-{schId}.dhtml
      // 手机版URL格式：/wap/zszc/zszclist?schId={schId}
      const desktopPattern = /\/zsgs\/zhangcheng\/listZszc--schId-(\d+)\.dhtml/;
      const match = url.match(desktopPattern);

      if (match) {
        const schId = match[1];
        // 转换为手机版URL
        const mobileUrl = `https://gaokao.chsi.com.cn/wap/zszc/zszclist?schId=${schId}`;
        console.log('转换URL:', url, '->', mobileUrl);
        return mobileUrl;
      }

      // 如果不匹配电脑版格式，返回原URL
      return url;
    },

    handleTableScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      const threshold = 50;
      const isNearBottom = scrollHeight - (scrollTop + clientHeight) < threshold;
      
      if (isNearBottom && !this.isLoadingMore && this.hasMoreData) {
        this.loadMoreData();
      }
    },
    
    //双击显示全部 - 带权限检查
    async showFullContent(row, column, event) {
      const cell = event.target.closest('.cell');
      if (!cell) return;

      // 获取字段名和当前值
      const fieldName = column.property;
      const oldValue = row[fieldName];

      // 创建浮层容器
      const overlay = document.createElement('div');
      overlay.style.position = 'absolute';
      overlay.style.zIndex = '9999';
      overlay.style.backgroundColor = 'white';
      overlay.style.border = '1px solid #409EFF';
      overlay.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
      overlay.style.padding = '10px';
      
      // 计算位置
      const rect = cell.getBoundingClientRect();
      overlay.style.left = `${rect.left}px`;
      overlay.style.top = `${rect.top}px`;
      overlay.style.width = `${Math.max(rect.width, 300)}px`; // 最小宽度300px
      
      // 创建可编辑的textarea元素
      const textarea = document.createElement('textarea');
      textarea.value = oldValue;
      textarea.style.width = '100%';
      textarea.style.minHeight = '100px';
      textarea.style.border = 'none';
      textarea.style.outline = 'none';
      textarea.style.resize = 'vertical';
      
      // 添加到浮层
      overlay.appendChild(textarea);
      document.body.appendChild(overlay);
      
      // 自动聚焦
      textarea.focus();
      
      // 标记是否已经处理过
      let isProcessed = false;
      
      // 点击外部关闭浮层并保存修改
      const closeOverlay = async (e) => {
          if (isProcessed) return;
          if (!overlay.contains(e.target)) {
              isProcessed = true;
              const newValue = textarea.value;
              document.body.removeChild(overlay);
              document.removeEventListener('click', closeOverlay);

              // 更新行数据
              if (newValue !== oldValue) {
                row[fieldName] = newValue;
              }
          }
      };
      
      document.addEventListener('click', closeOverlay);
    },

    // 显示悬停提示框
    showHoverTooltip(row, column, cell, event) {
      // 小屏幕设备不使用悬停提示，使用点击显示
      const isSmallScreen = window.innerWidth < 768;
      if (isSmallScreen) return;

      // 确保 cell 参数存在（兼容不同Element UI版本）
      // cell-mouse-enter 事件参数: (row, column, cell, event)
      let targetCell = cell;
      if (!targetCell && event && event.target) {
        targetCell = event.target.closest('.el-table__cell') || event.target.closest('td');
      }
      if (!targetCell) return;

      // 获取字段值
      const fieldName = column.property;
      const value = row[fieldName];

      // 如果没有值，不显示悬停提示
      if (!value) return;

      // 检查单元格内容是否被截断（有省略号...）
      const cellContent = targetCell.querySelector('.cell');
      if (!cellContent) return;

      // 判断内容是否溢出：scrollHeight > clientHeight 表示内容被截断（有省略号）
      // 使用 2px 的容差来避免浮点数精度问题
      const isOverflowing = cellContent.scrollHeight > cellContent.clientHeight + 2;
      
      // 只有内容溢出（有省略号...）的才显示悬停提示
      if (!isOverflowing) return;

      // 移除已存在的tooltip
      if (targetCell._tooltip) {
        this.hideHoverTooltip(row, column, targetCell);
      }

      // 创建提示框
      const tooltip = document.createElement('div');
      tooltip.className = 'hover-tooltip';
      tooltip.style.position = 'fixed';
      tooltip.style.zIndex = '9998';
      tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
      tooltip.style.color = 'white';
      tooltip.style.padding = '8px 12px';
      tooltip.style.borderRadius = '4px';
      tooltip.style.fontSize = '12px';
      tooltip.style.maxWidth = '400px';
      tooltip.style.wordWrap = 'break-word';
      tooltip.style.pointerEvents = 'none';
      tooltip.style.opacity = '0';
      tooltip.style.transition = 'opacity 0.2s';
      tooltip.textContent = value;

      // 计算位置
      const rect = targetCell.getBoundingClientRect();
      tooltip.style.left = `${rect.left}px`;
      tooltip.style.top = `${rect.bottom + 5}px`;

      document.body.appendChild(tooltip);

      // 显示动画
      requestAnimationFrame(() => {
        tooltip.style.opacity = '1';
      });

      // 存储tooltip引用到cell上，方便移除
      targetCell._tooltip = tooltip;
    },

    // 隐藏悬停提示框
    hideHoverTooltip(row, column, cell, event) {
      // 小屏幕设备不处理
      const isSmallScreen = window.innerWidth < 768;
      if (isSmallScreen) return;

      // 兼容不同Element UI版本
      let targetCell = cell;
      if (!targetCell && event && event.target) {
        targetCell = event.target.closest('.el-table__cell') || event.target.closest('td');
      }
      if (!targetCell || !targetCell._tooltip) return;

      const tooltip = targetCell._tooltip;
      tooltip.style.opacity = '0';
      setTimeout(() => {
        if (tooltip.parentNode) {
          document.body.removeChild(tooltip);
        }
      }, 200);
      targetCell._tooltip = null;
    },

    // 小屏幕单击显示内容（替代悬停）
    showContentOnSmallScreen(row, column, cell) {
      const isSmallScreen = window.innerWidth < 768;
      if (!isSmallScreen) return;

      // 小屏幕上，单击显示内容（区别于双击）
      // 使用防抖，避免连续点击
      if (this._clickTimer) {
        clearTimeout(this._clickTimer);
        this._clickTimer = null;
        // 如果这是第二次点击，视为双击，让原有双击事件处理
        return;
      }

      this._clickTimer = setTimeout(() => {
        this._clickTimer = null;

        // cell 参数就是单元格元素
        if (!cell) return;

        // 获取字段值
        const fieldName = column.property;
        const value = row[fieldName];

        // 如果值太短不需要显示
        if (!value || value.toString().length < 10) return;

        // 创建提示框（无关闭按钮，失去焦点自动关闭）
        const tooltip = document.createElement('div');
        tooltip.className = 'mobile-tooltip';
        tooltip.style.position = 'fixed';
        tooltip.style.zIndex = '9999';
        tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
        tooltip.style.color = 'white';
        tooltip.style.padding = '12px 16px';
        tooltip.style.borderRadius = '8px';
        tooltip.style.fontSize = '14px';
        tooltip.style.maxWidth = '80%';
        tooltip.style.maxHeight = '60vh';
        tooltip.style.overflow = 'auto';
        tooltip.style.wordWrap = 'break-word';
        tooltip.style.left = '50%';
        tooltip.style.top = '50%';
        tooltip.style.transform = 'translate(-50%, -50%)';
        tooltip.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
        tooltip.tabIndex = '-1'; // 使元素可以获得焦点
        tooltip.setAttribute('role', 'dialog');
        tooltip.setAttribute('aria-modal', 'true');

        // 添加内容
        const content = document.createElement('div');
        content.textContent = value;

        tooltip.appendChild(content);
        document.body.appendChild(tooltip);

        // 立即获取焦点
        tooltip.focus();

        // 失去焦点或按ESC键关闭
        const closeHandler = () => {
          if (document.body.contains(tooltip)) {
            document.body.removeChild(tooltip);
          }
          document.removeEventListener('click', closeOnOutside);
          tooltip.removeEventListener('blur', closeHandler);
        };

        // 点击外部关闭
        const closeOnOutside = (e) => {
          if (!tooltip.contains(e.target)) {
            closeHandler();
          }
        };

        tooltip.addEventListener('blur', closeHandler);
        tooltip.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' || e.key === 'Esc') {
            closeHandler();
          }
        });

        // 延迟添加点击外部监听，避免立即触发
        setTimeout(() => {
          document.addEventListener('click', closeOnOutside);
        }, 100);
      }, 250); // 250ms 后执行，如果期间再次点击则取消（双击）
    },

    // 检查分数修改权限
    async checkScoreChangePermission() {
      try {
        // 管理员不受限制
        if (this.isSuperAdmin && !['用户', '0'].includes(this.isSuperAdmin)) {
          return true;
        }

        const response = await axios.get('api/check-score-change-limit/', {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });

        if (response.data.success) {
          if (!response.data.can_change) {
            this.$message.warning(response.data.message || '您已达到修改次数限制');
            return false;
          }
          return true;
        }
        return false;
      } catch (error) {
        console.error('检查权限失败:', error);
        // 如果检查失败，默认允许修改
        return true;
      }
    },

    // 检查筛选权限
    async checkFilterPermission() {
      try {
        // 管理员不受限制
        if (this.isSuperAdmin && !['用户', '0'].includes(this.isSuperAdmin)) {
          return true;
        }

        const response = await axios.get('api/check-filter-permission/', {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });

        if (response.data.success) {
          if (!response.data.can_filter) {
            this.$message.warning(response.data.message || '您没有筛选权限');
            return false;
          }
          return true;
        }
        return false;
      } catch (error) {
        console.error('检查筛选权限失败:', error);
        // 如果检查失败，默认允许筛选
        return true;
      }
    },

    // 记录分数修改
    async recordScoreChange(field, oldValue, newValue) {
      try {
        const response = await axios.post('api/record-score-change/', {
          field: field,
          old_value: oldValue,
          new_value: newValue
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });

        // console.log('recordScoreChange 完整响应:', response.data);

        // 如果成功返回了剩余次数，直接更新
        if (response.data.success && response.data.remaining !== undefined) {
          // console.log(`更新剩余次数: ${response.data.remaining}, 可修改: ${response.data.can_change}`);
          if (typeof this.updateScoreChangeRemaining === 'function') {
            this.updateScoreChangeRemaining(response.data.remaining, response.data.can_change);
          } else if (typeof this.loadScoreChangeLimitInfo === 'function') {
            // 如果没有updateScoreChangeRemaining方法，则重新加载
            this.loadScoreChangeLimitInfo();
          }
          // 显示成功提示（管理员/超级管理员 remaining 为 -1，不显示提示）
          if (this.$message && response.data.remaining !== -1) {
            this.$message.success(`修改成功！剩余修改次数：${response.data.remaining} 次`);
          }
        }
      } catch (error) {
        console.error('记录修改失败:', error);
        // 403 错误不影响位次更新，只是不记录修改历史
        if (error.response?.status === 403) {
          console.log('用户未登录或登录已过期，跳过记录修改');
        }
      }
    },
    // 设置滚动监听器
    // setupScrollListener() {
    //   this.$nextTick(() => {
    //     const tableWrapper = document.querySelector('.el-table__body-wrapper')
    //     if (tableWrapper) {
    //       tableWrapper.addEventListener('scroll', (e) => {
    //         const { scrollTop, scrollHeight, clientHeight } = e.target
    //         const threshold = 50
    //         const isNearBottom = scrollHeight - (scrollTop + clientHeight) < threshold
            
    //         if (isNearBottom && !this.isLoadingMore && this.hasMoreData) {
    //           this.loadMoreData()
    //         }
    //       })
    //     }
    //   })
    // },
    
    // 滚动到指定ID的元素
    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    
    // 阻止按键事件
    preventKeydown(e) {
      e.preventDefault()
    },
    
    // 失去焦点
    blurInput(e) {
      e.target.blur()
    },
    
    // 清除输入
    clearInput(e) {
      e.target.value = ''
      // 触发 input 事件以更新 v-model 绑定的值
      e.target.dispatchEvent(new Event('input'))
    },
    
    // 选择项 - 支持多选
    selectItem(row, event) {
      // 初始化多选相关属性（如果不存在）
      if (!this.selectedRows) {
        this.selectedRows = [];
      }
      if (!this.selectedIndices) {
        this.selectedIndices = [];
      }
      
      // 获取当前行在列表中的索引
      const itemIndex = this.wishList.findIndex(item => item === row);
      // 查找当前行是否已在选中列表中
      const existingIndex = this.selectedRows.findIndex(item => item === row);
      
      // 初始化全局按键状态跟踪（如果尚未初始化）
      if (window._isCtrlPressed === undefined) {
        window._isCtrlPressed = false;
        
        // 设置全局按键状态监听
        window.addEventListener('keydown', (e) => {
          window._isCtrlPressed = e.ctrlKey || e.metaKey || e.shiftKey;
        });
        
        window.addEventListener('keyup', () => {
          window._isCtrlPressed = false;
        });
      }
      
      // 最可靠的方式检测Ctrl键
      const isMultiSelectKeyPressed = 
        (event && (event.ctrlKey || event.metaKey || event.shiftKey)) || 
        window._isCtrlPressed;
      
      if (!isMultiSelectKeyPressed) {
        // 单选模式：清除现有选择并只选择当前行
        this.selectedRows = [row];
        this.selectedIndices = [itemIndex];
      } else {
        // 多选模式：切换当前行选中状态
        if (existingIndex > -1) {
          // 如果已选中，则移除
          this.selectedRows.splice(existingIndex, 1);
          this.selectedIndices.splice(existingIndex, 1);
        } else {
          // 如果未选中，则添加
          this.selectedRows.push(row);
          this.selectedIndices.push(itemIndex);
        }
      }
      
      // 更新单选状态（用于兼容其他功能）
      this.selectedRow = row;
      this.selectedIndex = itemIndex;
      
      // 立即更新样式，确保所有选中行都能正确高亮
      this.$nextTick(() => {
        this.updateSelectionStyles();
      });
      
      // 显示选中数量信息
      if (this.$message) {
        this.$message.closeAll();
        setTimeout(() => {
          if (this.selectedRows.length > 0) {
            // this.$message.info(`当前已选中 ${this.selectedRows.length} 项`);
          }
        }, 0);
      }
    },
    
    // 辅助方法：获取表格行元素
    getTableRows() {
      // 同时尝试两种选择器，确保能找到表格
      const wishTable = document.querySelector('.wish-table') || document.querySelector('.wishtable');
      if (wishTable) {
        return wishTable.querySelectorAll('.el-table__row');
      }
      
      // 如果特定表格不存在，则尝试找到所有el-table元素
      const allTables = document.querySelectorAll('.el-table');
      if (allTables.length > 0) {
        // 尝试从第一个表格中获取行
        return allTables[0].querySelectorAll('.el-table__row');
      }
      
      return [];
    },
    
    // 优化updateSelectionStyles方法，确保样式正确应用
    updateSelectionStyles() {
      // 使用setTimeout确保DOM更新后再应用样式
      setTimeout(() => {
        // 获取所有表格行
        const targetRows = this.getTableRows();
        
        // 先清除所有行的选中样式
        targetRows.forEach(row => {
          row.classList.remove('table-row-selected');
          row.style.backgroundColor = '';
          row.style.border = '';
          row.style.fontWeight = '';
        });
        
        // 为当前选中的索引添加样式
        if (this.selectedIndices && this.selectedIndices.length > 0) {
          this.selectedIndices.forEach(index => {
            if (index >= 0 && index < targetRows.length) {
              targetRows[index].classList.add('table-row-selected');
            }
          });
        }
      }, 50); // 缩短延迟，提高响应速度
    },
    
    // 上移选中项 - 支持多选
    moveItemUp() {
      // 多选模式
      if (this.selectedRows && this.selectedRows.length > 0) {
        // 对选中的索引进行排序（从小到大）
        const sortedIndices = [...this.selectedIndices].sort((a, b) => a - b);
        
        // 精确检查：如果最小的索引是0，说明有项目已经在最顶部，不能再上移
        if (Math.min(...sortedIndices) === 0) {
          return;
        }
        
        // 创建选中行的深拷贝
        const selectedRowsCopy = [...this.selectedRows];
        let movedCount = 0;
        
        // 先清除选中状态
        this.selectedRows = [];
        this.selectedIndices = [];
        
        // 从最小索引开始向上移动
        sortedIndices.forEach(index => {
          // 确保项可以上移
          if (index > 0) {
            // 交换位置
            const temp = this.wishList[index];
            this.$set(this.wishList, index, this.wishList[index - 1]);
            this.$set(this.wishList, index - 1, temp);
            movedCount++;
          }
        });
        
        // 重新查找并更新选中项
        selectedRowsCopy.forEach(row => {
          const newIndex = this.wishList.indexOf(row);
          if (newIndex !== -1) {
            this.selectedRows.push(row);
            this.selectedIndices.push(newIndex);
          }
        });
        
        if (movedCount > 0) {
          this.selectedIndex = this.selectedIndices.length > 0 ? Math.min(...this.selectedIndices) : -1;
          // 确保更新样式
          this.$nextTick(() => {
            this.updateSelectionStyles();
          });
        }
      } 
      // 兼容单选模式
      else if (this.selectedIndex > 0) {
        const temp = this.wishList[this.selectedIndex];
        this.$set(this.wishList, this.selectedIndex, this.wishList[this.selectedIndex - 1]);
        this.$set(this.wishList, this.selectedIndex - 1, temp);
        this.refreshDisplayWishData();
        this.selectedIndex--;
        // 确保更新样式
        this.$nextTick(() => {
          this.updateSelectionStyles();
        });
      }
    },

    // 下移选中项 - 支持多选
    moveItemDown() {
      // 多选模式
      if (this.selectedRows && this.selectedRows.length > 0) {
        // 对选中的索引进行排序（从大到小）
        const sortedIndices = [...this.selectedIndices].sort((a, b) => b - a);
        const listLength = this.wishList.length;
        
        // 精确检查：如果最大的索引是listLength-1，说明有项目已经在最底部，不能再下移
        if (Math.max(...sortedIndices) === listLength - 1) {
          return;
        }
        
        // 创建选中行的深拷贝
        const selectedRowsCopy = [...this.selectedRows];
        let movedCount = 0;
        
        // 先清除选中状态
        this.selectedRows = [];
        this.selectedIndices = [];
        
        // 从最大索引开始向下移动
        sortedIndices.forEach(index => {
          // 确保项可以下移
          if (index < listLength - 1) {
            // 交换位置
            const temp = this.wishList[index];
            this.$set(this.wishList, index, this.wishList[index + 1]);
            this.$set(this.wishList, index + 1, temp);
            movedCount++;
          }
        });
        this.refreshDisplayWishData();
        
        // 重新查找并更新选中项
        selectedRowsCopy.forEach(row => {
          const newIndex = this.wishList.indexOf(row);
          if (newIndex !== -1) {
            this.selectedRows.push(row);
            this.selectedIndices.push(newIndex);
          }
        });
        
        if (movedCount > 0) {
          this.selectedIndex = this.selectedIndices.length > 0 ? Math.min(...this.selectedIndices) : -1;
          this.$message.success(`已下移 ${movedCount} 项`);
          
          // 确保更新样式
          this.$nextTick(() => {
            this.updateSelectionStyles(); 
          }); 
        }
      } 
      // 兼容单选模式
      else if (this.selectedIndex < this.wishList.length - 1 && this.selectedIndex !== -1) {
        const temp = this.wishList[this.selectedIndex];
        this.$set(this.wishList, this.selectedIndex, this.wishList[this.selectedIndex + 1]);
        this.$set(this.wishList, this.selectedIndex + 1, temp);
        this.refreshDisplayWishData();
        this.selectedIndex++;
        this.$message.success('已下移选中项');
        
        // 确保更新样式
        this.$nextTick(() => {
          this.updateSelectionStyles();
        });
      }
    },
    
    // 删除选中项 - 支持多选
    deleteSelectedItem() {
      try {
        if (this.selectedRows && this.selectedRows.length > 0) {
          // 多选模式
          const count = this.selectedRows.length;
          this.$confirm(`确定要删除选中的 ${count} 项吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 先清除所有选中样式
            const allRows = document.querySelectorAll('.el-table__row');
            allRows.forEach(row => {
              row.classList.remove('table-row-selected');
            });
            
            // 使用简单直接的方法删除选中项
            // 按从大到小排序，避免索引变化问题
            const sortedIndices = [...this.selectedIndices].sort((a, b) => b - a);
            
            // 逐个删除
            sortedIndices.forEach(index => {
              this.wishList.splice(index, 1);
              this.refreshDisplayWishData();
            });
            
            // 清空选择状态
            this.selectedRows = [];
            this.selectedIndices = [];
            this.selectedIndex = -1;
            
            // 添加日志以便调试
            console.log('删除后的志愿表长度:', this.wishList.length);
            
            this.$message.success(`已删除 ${count} 项`);
          }).catch(() => {
            this.$message.info('已取消删除');
          });
        } else if (this.selectedIndex !== -1) {
          // 单选模式 - 使用简单直接的实现
          this.$confirm('确定要删除选中项吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 清除样式
            const allRows = document.querySelectorAll('.el-table__row');
            allRows.forEach(row => {
              row.classList.remove('table-row-selected');
            });
            
            // 使用简单直接的方法删除
            this.wishList.splice(this.selectedIndex, 1);
            this.refreshDisplayWishData();
            this.selectedIndex = -1;
            this.$message.success('已删除选中项');
          }).catch(() => {
            this.$message.info('已取消删除');
          });
        } else {
          this.$message.warning('请先选择要删除的项');
        }
      } catch (e) {
        console.error('删除选中项出错:', e);
        this.$message.error('删除失败: ' + e.message);
      }
    },
    // 复制选中项 - 支持多选
    
    // 清空志愿表
    clearWishList() {
      try {
        this.$confirm('确定要清空整个志愿表吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.wishList = [];
          this.selectedIndex = -1;
          this.clearAllWishColumnFilters();
          this.$message.success('已清空志愿表');
        }).catch(() => {
          this.$message.info('已取消清空');
        });
      } catch (e) {
        console.error('清空志愿表出错:', e);
        this.$message.error('清空失败: ' + e.message);
      }
    },
    // 获取项目的位次
    _getItemRank(item) {
      if (item.l_rnk != null) return Number(item.l_rnk);
      if (item.admission_rank != null) return Number(item.admission_rank);
      if (item.最低位次 != null) return Number(item.最低位次);
      return null;
    },
    // 获取项目的分数
    _getItemScore(item) {
      if (item.l_scr != null) return Number(item.l_scr);
      if (item.score != null) return Number(item.score);
      if (item.same_rank_score != null) return Number(item.same_rank_score);
      return null;
    },
    // 自动排序志愿表
    autoSortWishList() {
      if (!this.wishList || this.wishList.length === 0) {
        this.$message.warning('志愿表为空，无法排序');
        return;
      }
      
      const sortMode = this.wishSortMode || 'maxRank';
      
      // 如果选的是"组内最低位次排序"但没有 group_actual_min_rank 数据，先触发筛选重新获取
      if (sortMode === 'minScoreRank') {
        const hasGroupRankData = this.wishList.some(item => item.group_actual_min_rank != null);
        if (!hasGroupRankData) {
          this.$message.info('缺少组内最低位次数据，正在重新获取...');
          if (typeof this.handleFilterSearch === 'function') {
            this.handleFilterSearch();
          }
          return;
        }
      }
      
      try {
        // 首先对志愿表进行分组
        const groupedData = {};

        // 按学校名、科类、再选科目、专业组分
        this.wishList.forEach(item => {
          const schoolName = item.school_name || '';
          const subject = item.subject || '';
          const subCombo = item.sub_combo || '';
          const majorGroup = item.major_group || '';
          const groupKey = `${schoolName}_${subject}_${subCombo}_${majorGroup}`;

          if (!groupedData[groupKey]) {
            groupedData[groupKey] = {
              items: [],
              schoolName,
              subject,
              subCombo,
              majorGroup,
              maxRank: -1, // A方案：组内各专业自身位次的最大值
              groupMinRank: null, // B方案：组内最低位次（与表格"本组最低:位次"一致，来自后端 group_actual_min_rank）
            };
          }

          groupedData[groupKey].items.push(item);

          // A方案：组内各专业自身位次的最大值
          const rank = this._getItemRank(item);
          if (rank != null && rank > groupedData[groupKey].maxRank) {
            groupedData[groupKey].maxRank = rank;
          }

          // B方案：取该组的 group_actual_min_rank（同组所有 item 同一值，取一次即可）
          if (groupedData[groupKey].groupMinRank == null && item.group_actual_min_rank != null) {
            groupedData[groupKey].groupMinRank = Number(item.group_actual_min_rank);
          }
        });

        // 将分组转换为数组
        const groupArray = Object.values(groupedData);
        
        // 按选择的排序方式对组间排序
        if (sortMode === 'minScoreRank') {
          // 方式2（B）：表格中"本组最低:位次"升序（位次号小的组优先）
          groupArray.sort((a, b) => (a.groupMinRank ?? Infinity) - (b.groupMinRank ?? Infinity));
        } else {
          // 方式1（A，默认）：组内各专业自身位次的最大值升序（位次号小=分数高，排前面）
          groupArray.sort((a, b) => a.maxRank - b.maxRank);
        }
        
        // 对每个组内的项目按位次从低到高排序（位次号小优先）
        const sortedWishList = [];
        groupArray.forEach(group => {
          // 按位次从低到高排序（位次号小优先），显式判断 null/undefined 避免 0 被短路
          group.items.sort((a, b) => {
            const rankA = this._getItemRank(a) ?? Infinity;
            const rankB = this._getItemRank(b) ?? Infinity;
            return rankA - rankB;
          });
          
          // 将排序后的组内项目添加到结果数组
          sortedWishList.push(...group.items);
        });
        
        // 更新志愿表
        this.wishList = sortedWishList;
        this.selectedIndex = -1;
        this.$message.success('志愿表已自动排序');
      } catch (error) {
        console.error('自动排序出错:', error);
        this.$message.error('排序失败: ' + error.message);
      }
    },
    // 拖拽开始
    handleDragStart(row) {
      this.draggedRow = row;
    },
    
    // 拖拽经过
    handleDragOver(row) {
      if (this.draggedRow && this.draggedRow !== row) {
        const draggedIndex = this.wishList.indexOf(this.draggedRow);
        const targetIndex = this.wishList.indexOf(row);
        
        // 交换位置
        this.$set(this.wishList, draggedIndex, row);
        this.$set(this.wishList, targetIndex, this.draggedRow);
        this.refreshDisplayWishData();
      }
    },
    
    // 拖拽结束
    handleDragEnd() {
      this.draggedRow = null;
      this.$message.success('志愿表顺序已更新');
    },
    
    // 右键菜单
    // 修复handleRightClick方法，确保两个表格的右键菜单功能
    handleRightClick(row, column, event) {
    event.preventDefault();
    this.selectedRow = row;
    
    // 确定是在哪个表格上右键点击
    let isWishTable = false;
    let element = event.target;
    
    // 查找最近的el-table元素
    while (element && element !== document.body) {
    if (element.classList && element.classList.contains('el-table')) {
    isWishTable = element.classList.contains('wishtable');
    break;
    }
    element = element.parentElement;
    }
    
    if (isWishTable) {
    // 如果是志愿表，调用志愿表的右键菜单
    this.showWishListContextMenu(event);
    } else {
    // 否则使用筛选表右键菜单
    this.showFilterTableContextMenu(event);
    }
    },
    // 首先添加显示招生计划的方法
    async showSchoolPlan() {
      try {
        this.isLoading = true;
        // 发送请求到后端查询招生计划数据
      
        const rowData = this.selectedRow || {};
        
        // 构建查询数据对象 - 查询该组所有专业的招生计划
        const queryData = {
          // 从选中行获取数据
          origin: rowData.origin || rowData.生源地 || '',
          batch: rowData.batch || rowData.批次 || '',
          subject: rowData.subject || rowData.subject1 || rowData.科类 || '',
          school_name: rowData.school_name || rowData.学校名称 || '',
          major_group: rowData.major_group || rowData.专业组 || '',
          // 不传major_name，显示该组所有专业的数据
        };
        
        // 修复API路径
        // 获取csrftoken
        // const csrftoken = getCookie('csrftoken');
        const response = await axios.post('api/getSchoolPlan/', {
          selectItem: queryData
        }, {
          // withCredentials: true,  // 启用Cookie传递
          // headers: {
          //     'X-Csrftoken': csrftoken
          // },
          // credentials: 'include',  // 确保发送cookie
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
      });
        
        if (response.data && response.data.success) {
          const planData = response.data.data || response.data.plan_data || [];
      
          if (planData && planData.length > 0) {
            // 创建英文到中文的列名映射
            const columnNameMap = {
                'admit_year': '年份',
                'origin': '生源地',
                'batch': '批次',
                'school_name': '学校名',
                'subject': '科类',
                'school_code': '学校代码',
                'major_group': '专业组',
                'major_code': '专业代码',
                'major_name': '专业名称',
                'sub_combo': '再选科目',
                'remark': '专业备注',
                'plan': '计划数',
                'duration': '学年',
                'money': '学费'
            };
            
            // 创建处理后的数据，确保所有字段都可访问
            const processedData = planData.map(item => {
              const result = {};
              // 遍历所有原始字段，确保每个字段都能被访问
              Object.keys(item).forEach(key => {
                result[key] = item[key];
              });
              return result;
            });
            // this.$message.warning(planData);
            // 获取列名并转换为中文（排除内部字段）
            const hiddenKeys = ['sortcol'];
            const columns = processedData.length > 0 ? 
                Object.keys(processedData[0]).filter(k => !hiddenKeys.includes(k)).map(col => columnNameMap[col] || col) : 
                [];
            // this.$message.warning(columns);
            generateResultTable.createResultModal({
              title: `${queryData.school_name} 招生计划`,
              data: planData,
              columns: columns
            }, this);
          } else {
            this.$message.warning('未找到该学校的招生计划信息');
          }
        } else {
          this.$message.error('获取招生计划失败: ' + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error('查询招生计划时出错:', error);
        this.$message.error('查询招生计划失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    },
    // 显示学校基本信息方法
    async showSchoolInfo() {
      try {
        this.isLoading = true;
        // 从选中行获取学校名称
        const rowData = this.selectedRow || {};
        const schoolName = rowData.school_name || rowData.学校名称 || '';

        if (!schoolName) {
          this.$message.warning('无法获取学校名称');
          return;
        }

        // 发送请求到后端查询学校基本信息
        const response = await axios.post('api/fetchUniversityBasicInfo/', {
          schoolNames: [schoolName]
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });

        if (response.data && response.data.success) {
          const dataMap = response.data.data || {};
          const schoolInfo = dataMap[schoolName];

          if (schoolInfo) {
            // 构建竖排键值对表格数据
            const fieldMappings = [
              { field: '学校名称',      value: schoolName },
              { field: '排名',          value: schoolInfo.ranking || '' },
              { field: '简称',          value: schoolInfo.abbreviation || '' },
              { field: '英文名字',      value: schoolInfo.english_name || '' },
              { field: '学校代码',      value: schoolInfo.school_code || '' },
              { field: '学校省份',      value: schoolInfo.province || '' },
              { field: '城市',          value: schoolInfo.city || '' },
              { field: '汇总标签',      value: schoolInfo.tags || '' },
              { field: '专业评估结果',  value: schoolInfo.major_evaluation_results || '' },
              { field: '推荐专业',      value: schoolInfo.recommended_majors || '' },
              { field: '创建时间',      value: schoolInfo.established_year || '' },
              { field: '女生比例',      value: schoolInfo.female_ratio || '' },
              { field: '男生比例',      value: schoolInfo.male_ratio || '' },
              { field: '自然类型',      value: schoolInfo.location_type || '' },
              { field: '学校类型',      value: schoolInfo.institution_type || '' },
              { field: '所属机构',      value: schoolInfo.affiliated || '' },
              { field: '简单标签',      value: schoolInfo.simple_tag || '' },
              { field: '是否艺术',      value: schoolInfo.is_art || '' },
              { field: '是否985',       value: schoolInfo.is_985 || '' },
              { field: '是否211',       value: schoolInfo.is_211 || '' },
              { field: '是否国重点',    value: schoolInfo.is_national_key || '' },
              { field: '是否是私立',    value: schoolInfo.is_private || '' },
              { field: '世界排名',      value: schoolInfo.world_ranking || '' },
              { field: '排名汇总',      value: schoolInfo.ranking_summary || '' },
              { field: '硕士点',        value: schoolInfo.master_programs || '' },
              { field: '博士点',        value: schoolInfo.doctoral_programs || '' },
              { field: '世界一流',      value: schoolInfo.world_class_discipline || '' },
              { field: '一流大学',      value: schoolInfo.first_class_university || '' },
              { field: '描述',          value: schoolInfo.description || '' },
              { field: '本科or专科',    value: schoolInfo.undergraduate_or_vocational || '' },
              { field: '招办电话',      value: schoolInfo.admissions_phone || '' },
              { field: '电子邮箱',      value: schoolInfo.email || '' },
              { field: '通讯地址',      value: schoolInfo.mailing_address || '' },
              { field: '官网',          value: schoolInfo.official_website || '' },
              { field: '名人',          value: schoolInfo.notable_alumni || '' },
              { field: '就业情况',      value: schoolInfo.employment_statistics || '' },
              { field: '图片ID',        value: schoolInfo.image_id || '' }
            ];
            const verticalColumns = ['字段', '内容'];

            // 创建模态框显示学校信息（竖排键值对格式）
            generateResultTable.createResultModal({
              title: `${schoolName} 学校信息`,
              data: fieldMappings,
              columns: verticalColumns
            }, this);
          } else {
            this.$message.warning('未找到该学校的基本信息');
          }
        } else {
          this.$message.error('获取学校信息失败: ' + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error('查询学校信息时出错:', error);
        this.$message.error('查询学校信息失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    }, 
    // 添加筛选表的右键菜单方法
    showFilterTableContextMenu(event) {
    // 先移除已存在的菜单
    const existingMenu = document.querySelector('.custom-context-menu');
    if (existingMenu) {
    document.body.removeChild(existingMenu);
    }
    
    const menu = document.createElement('div');
    menu.className = 'custom-context-menu';
    menu.style.position = 'absolute';
    menu.style.left = `${event.clientX}px`;
    menu.style.top = `${event.clientY}px`;
    menu.style.zIndex = '9999';
    menu.style.backgroundColor = 'white';
    menu.style.border = '1px solid #ccc';
    menu.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
    
    // 菜单项：添加到志愿表
    const addButton = document.createElement('button');
    addButton.textContent = '添加到志愿表';
    addButton.style.display = 'block';
    addButton.style.width = '100%';
    addButton.style.padding = '8px 16px';
    addButton.style.textAlign = 'left';
    addButton.style.border = 'none';
    addButton.style.background = 'none';
    addButton.style.cursor = 'pointer';
    
    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(addButton);
    
    addButton.addEventListener('click', () => {
    this.checkYearAndConfirmAdd(this.selectedRow);
    if (document.body.contains(menu)) {
    document.body.removeChild(menu);
    }
    });
    
    menu.appendChild(addButton);
    
    // 添加分隔线
    const separator1 = document.createElement('div');
    separator1.style.height = '1px';
    separator1.style.backgroundColor = '#f0f0f0';
    separator1.style.margin = '5px 0';
    menu.appendChild(separator1);
    
    // 菜单项：组内最低分
    const minScoreButton = document.createElement('button');
    minScoreButton.textContent = '组内最低分';
    minScoreButton.style.display = 'block';
    minScoreButton.style.width = '100%';
    minScoreButton.style.padding = '8px 16px';
    minScoreButton.style.textAlign = 'left';
    minScoreButton.style.border = 'none';
    minScoreButton.style.background = 'none';
    minScoreButton.style.cursor = 'pointer';
    minScoreButton.style.borderTop = '1px solid #f0f0f0';
    
    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(minScoreButton);
    
    minScoreButton.addEventListener('click', () => {
    this.findGroupMinScore(this.selectedRow);
    if (document.body.contains(menu)) {
    document.body.removeChild(menu);
    }
    });
    
    menu.appendChild(minScoreButton);
    
    // 菜单项：显示组内所有专业
    const allMajorsButton = document.createElement('button');
    allMajorsButton.textContent = '显示组内所有专业';
    allMajorsButton.style.display = 'block';
    allMajorsButton.style.width = '100%';
    allMajorsButton.style.padding = '8px 16px';
    allMajorsButton.style.textAlign = 'left';
    allMajorsButton.style.border = 'none';
    allMajorsButton.style.background = 'none';
    allMajorsButton.style.cursor = 'pointer';
    allMajorsButton.style.borderTop = '1px solid #f0f0f0';
    
    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(allMajorsButton);
    
    allMajorsButton.addEventListener('click', () => {
    this.showAllGroupMajors(this.selectedRow);
    if (document.body.contains(menu)) {
    document.body.removeChild(menu);
    }
    });
    
    menu.appendChild(allMajorsButton);
    
    document.body.appendChild(menu);
    
    // 点击其他地方关闭菜单
    document.addEventListener('click', function closeMenu(e) {
    if (!menu.contains(e.target) && e.target !== event.target) {
    if (document.body.contains(menu)) {
    document.body.removeChild(menu);
    }
    document.removeEventListener('click', closeMenu);
    }
    });

    // 添加分隔线
    const separator2 = document.createElement('div');
    separator2.style.height = '1px';
    separator2.style.backgroundColor = '#f0f0f0';
    separator2.style.margin = '5px 0';
    menu.appendChild(separator2);
    
    // 菜单项：显示招生计划
    const showPlanButton = document.createElement('button');
    showPlanButton.textContent = '招生计划';
    showPlanButton.style.display = 'block';
    showPlanButton.style.width = '100%';
    showPlanButton.style.padding = '8px 16px';
    showPlanButton.style.textAlign = 'left';
    showPlanButton.style.border = 'none';
    showPlanButton.style.background = 'none';
    showPlanButton.style.cursor = 'pointer';
    showPlanButton.style.borderTop = '1px solid #f0f0f0';

    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(showPlanButton);

    showPlanButton.addEventListener('click', () => {
      // 直接调用showSchoolPlan，让函数内部处理获取数据的逻辑
      this.showSchoolPlan();

      // 清理菜单
      if (document.body.contains(menu)) {
        document.body.removeChild(menu);
      }
    });

    menu.appendChild(showPlanButton);

    // 菜单项：学校信息
    const showInfoButton = document.createElement('button');
    showInfoButton.textContent = '学校信息';
    showInfoButton.style.display = 'block';
    showInfoButton.style.width = '100%';
    showInfoButton.style.padding = '8px 16px';
    showInfoButton.style.textAlign = 'left';
    showInfoButton.style.border = 'none';
    showInfoButton.style.background = 'none';
    showInfoButton.style.cursor = 'pointer';
    showInfoButton.style.borderTop = '1px solid #f0f0f0';

    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(showInfoButton);

    showInfoButton.addEventListener('click', () => {
      // 调用showSchoolInfo方法
      this.showSchoolInfo();

      // 清理菜单
      if (document.body.contains(menu)) {
        document.body.removeChild(menu);
      }
    });

    menu.appendChild(showInfoButton);

    document.body.appendChild(menu);

    // 菜单项：招生章程
    const admissionButton = document.createElement('button');
    admissionButton.textContent = '招生章程';
    admissionButton.style.display = 'block';
    admissionButton.style.width = '100%';
    admissionButton.style.padding = '8px 16px';
    admissionButton.style.textAlign = 'left';
    admissionButton.style.border = 'none';
    admissionButton.style.background = 'none';
    admissionButton.style.cursor = 'pointer';
    admissionButton.style.borderTop = '1px solid #f0f0f0';

    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(admissionButton);

    admissionButton.addEventListener('click', async () => {
    if (this.selectedRow && this.selectedRow.school_name) {
          try {
          // 获取csrftoken
          // const csrftoken = getCookie('csrftoken');
          // 使用导入的axios获取招生章程URL
          const response = await axios.post('api/getAdmissionUrl/', {
          school_name: this.selectedRow.school_name
          }, {
            // withCredentials: true,  // 启用Cookie传递
            // headers: {
            //     'X-Csrftoken': csrftoken
            // },
            // credentials: 'include',  // 确保发送cookie
            withCredentials: true,
            xsrfCookieName: 'csrftoken',
            xsrfHeaderName: 'X-Csrftoken',
        });
    if (response.data.success && response.data.netaddress) {
    // 在浏览器中打开地址
    // 检测是否为小屏设备（宽度小于768px）
    const isSmallScreen = window.innerWidth < 768;
    let url = response.data.netaddress;

    // 如果是小屏设备，转换URL为手机版
    if (isSmallScreen) {
      url = this.convertToMobileUrl(url);
    }

    window.open(url, '_blank');
    } else {
    this.$message.warning('未找到该学校的招生章程信息');
    }
    } catch (error) {
    console.error('获取招生章程信息失败:', error);
    this.$message.error('获取招生章程信息失败: ' + (error.message || error));
    }
    }

    if (document.body.contains(menu)) {
    document.body.removeChild(menu);
    }
    });

    menu.appendChild(admissionButton);

    },
    // 显示志愿表右键菜单
    // 修改showWishListContextMenu方法中的按钮创建部分
    showWishListContextMenu(event) {
    // 先移除已存在的菜单
    const existingMenu = document.querySelector('.custom-context-menu');
    if (existingMenu) {
    document.body.removeChild(existingMenu);
    }
    
    const menu = document.createElement('div');
    menu.className = 'custom-context-menu';
    menu.style.position = 'absolute';
    menu.style.left = `${event.clientX}px`;
    menu.style.top = `${event.clientY}px`;
    menu.style.zIndex = '9999';
    menu.style.backgroundColor = 'white';
    menu.style.border = '1px solid #ccc';
    menu.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
    
    // 菜单项：选中项上移
    const moveUpButton = document.createElement('button');
    moveUpButton.textContent = '选中项上移';
    moveUpButton.style.display = 'block';
    moveUpButton.style.width = '100%';
    moveUpButton.style.padding = '8px 16px';
    moveUpButton.style.textAlign = 'left';
    moveUpButton.style.border = 'none';
    moveUpButton.style.background = 'none';
    moveUpButton.style.cursor = 'pointer';
    
    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(moveUpButton);
    moveUpButton.addEventListener('click', () => {
    this.selectItem(this.selectedRow); // 确保选中当前行
    this.moveItemUp();
    if (document.body.contains(menu)) {
      document.body.removeChild(menu);
    }
    });
    
    menu.appendChild(moveUpButton);
    
    // 菜单项：选中项下移
    const moveDownButton = document.createElement('button');
    moveDownButton.textContent = '选中项下移';
    moveDownButton.style.display = 'block';
    moveDownButton.style.width = '100%';
    moveDownButton.style.padding = '8px 16px';
    moveDownButton.style.textAlign = 'left';
    moveDownButton.style.border = 'none';
    moveDownButton.style.background = 'none';
    moveDownButton.style.cursor = 'pointer';
    moveDownButton.style.borderTop = '1px solid #f0f0f0';
    
    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(moveDownButton);
    moveDownButton.addEventListener('click', () => {
    this.selectItem(this.selectedRow); // 确保选中当前行
    this.moveItemDown();
    if (document.body.contains(menu)) {
      document.body.removeChild(menu);
    }
    });
    
    menu.appendChild(moveDownButton);
    
    // 菜单项：删除选中项
    const deleteButton = document.createElement('button');
    deleteButton.textContent = '删除选中项';
    deleteButton.style.display = 'block';
    deleteButton.style.width = '100%';
    deleteButton.style.padding = '8px 16px';
    deleteButton.style.textAlign = 'left';
    deleteButton.style.border = 'none';
    deleteButton.style.background = 'none';
    deleteButton.style.cursor = 'pointer';
    deleteButton.style.borderTop = '1px solid #f0f0f0';
    
    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(deleteButton);
    deleteButton.addEventListener('click', () => {
    this.selectItem(this.selectedRow); // 确保选中当前行
    this.deleteSelectedItem();
    if (document.body.contains(menu)) {
      document.body.removeChild(menu);
    }
    });
    
    menu.appendChild(deleteButton);
    
    // 添加分隔线
    const separator = document.createElement('div');
    separator.style.height = '1px';
    separator.style.backgroundColor = '#f0f0f0';
    separator.style.margin = '5px 0';
    menu.appendChild(separator);
    
    // 菜单项：清空志愿表
    const clearButton = document.createElement('button');
    clearButton.textContent = '清空志愿表';
    clearButton.style.display = 'block';
    clearButton.style.width = '100%';
    clearButton.style.padding = '8px 16px';
    clearButton.style.textAlign = 'left';
    clearButton.style.border = 'none';
    clearButton.style.background = 'none';
    clearButton.style.cursor = 'pointer';
    clearButton.style.color = '#f56c6c'; // 保持红色文字
    // 修改清空按钮的悬停效果
    this.addSimpleHoverEffect(clearButton);
    
    clearButton.addEventListener('click', () => {
    this.clearWishList();
    if (document.body.contains(menu)) {
      document.body.removeChild(menu);
    }
    });
    
    menu.appendChild(clearButton);
    
    // 添加分隔线
    const separator2 = document.createElement('div');
    separator2.style.height = '1px';
    separator2.style.backgroundColor = '#f0f0f0';
    separator2.style.margin = '5px 0';
    menu.appendChild(separator2);
    
    // 菜单项：组内最低分
    const minScoreButton = document.createElement('button');
    minScoreButton.textContent = '组内最低分';
    minScoreButton.style.display = 'block';
    minScoreButton.style.width = '100%';
    minScoreButton.style.padding = '8px 16px';
    minScoreButton.style.textAlign = 'left';
    minScoreButton.style.border = 'none';
    minScoreButton.style.background = 'none';
    minScoreButton.style.cursor = 'pointer';
    minScoreButton.style.borderTop = '1px solid #f0f0f0';
    
    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(minScoreButton);
    minScoreButton.addEventListener('click', () => {
    this.findGroupMinScore(this.selectedRow);
    if (document.body.contains(menu)) {
      document.body.removeChild(menu);
    }
    });
    
    menu.appendChild(minScoreButton);
    
    // 菜单项：显示组内所有专业
    const allMajorsButton = document.createElement('button');
    allMajorsButton.textContent = '显示组内所有专业';
    allMajorsButton.style.display = 'block';
    allMajorsButton.style.width = '100%';
    allMajorsButton.style.padding = '8px 16px';
    allMajorsButton.style.textAlign = 'left';
    allMajorsButton.style.border = 'none';
    allMajorsButton.style.background = 'none';
    allMajorsButton.style.cursor = 'pointer';
    allMajorsButton.style.borderTop = '1px solid #f0f0f0';
    
    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(allMajorsButton);
    allMajorsButton.addEventListener('click', () => {
    this.showAllGroupMajors(this.selectedRow);
    if (document.body.contains(menu)) {
      document.body.removeChild(menu);
    }
    });
    
    menu.appendChild(allMajorsButton);

    // 添加分隔线
    const separator3 = document.createElement('div');
    separator3.style.height = '1px';
    separator3.style.backgroundColor = '#f0f0f0';
    separator3.style.margin = '5px 0';
    menu.appendChild(separator3);
    // 菜单项：显示招生计划
    const showPlanButton = document.createElement('button');
    showPlanButton.textContent = '招生计划';
    showPlanButton.style.display = 'block';
    showPlanButton.style.width = '100%';
    showPlanButton.style.padding = '8px 16px';
    showPlanButton.style.textAlign = 'left';
    showPlanButton.style.border = 'none';
    showPlanButton.style.background = 'none';
    showPlanButton.style.cursor = 'pointer';
    showPlanButton.style.borderTop = '1px solid #f0f0f0';
    
    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(showPlanButton);
    
    showPlanButton.addEventListener('click', () => {
      // 从选中行获取学校名称
      const school_name = this.selectedRow && (this.selectedRow.school_name);
      if (school_name) {
        this.showSchoolPlan(school_name);
      } else {
        this.$message.warning('无法获取学校名称');
      }

      if (document.body.contains(menu)) {
        document.body.removeChild(menu);
      }
    });

    menu.appendChild(showPlanButton);

    // 菜单项：学校信息
    const showInfoButton = document.createElement('button');
    showInfoButton.textContent = '学校信息';
    showInfoButton.style.display = 'block';
    showInfoButton.style.width = '100%';
    showInfoButton.style.padding = '8px 16px';
    showInfoButton.style.textAlign = 'left';
    showInfoButton.style.border = 'none';
    showInfoButton.style.background = 'none';
    showInfoButton.style.cursor = 'pointer';
    showInfoButton.style.borderTop = '1px solid #f0f0f0';

    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(showInfoButton);

    showInfoButton.addEventListener('click', () => {
      // 调用showSchoolInfo方法
      this.showSchoolInfo();

      // 清理菜单
      if (document.body.contains(menu)) {
        document.body.removeChild(menu);
      }
    });

    menu.appendChild(showInfoButton);

    document.body.appendChild(menu);

    // 菜单项：招生章程
    const admissionButton = document.createElement('button');
    admissionButton.textContent = '招生章程';
    admissionButton.style.display = 'block';
    admissionButton.style.width = '100%';
    admissionButton.style.padding = '8px 16px';
    admissionButton.style.textAlign = 'left';
    admissionButton.style.border = 'none';
    admissionButton.style.background = 'none';
    admissionButton.style.cursor = 'pointer';
    admissionButton.style.borderTop = '1px solid #f0f0f0';

    // 添加简单的背景悬停效果
    this.addSimpleHoverEffect(admissionButton);

    admissionButton.addEventListener('click', async () => {
    if (this.selectedRow && this.selectedRow.school_name) {
    try {
    // 获取csrftoken
    // const csrftoken = getCookie('csrftoken');
    // 使用导入的axios获取招生章程URL
    const response = await axios.post('api/getAdmissionUrl/', {
    school_name: this.selectedRow.school_name
    }, {
      // withCredentials: true,  // 启用Cookie传递
      // headers: {
      //     'X-Csrftoken': csrftoken
      // }
      withCredentials: true,
      xsrfCookieName: 'csrftoken',
      xsrfHeaderName: 'X-Csrftoken',
  });

    if (response.data.success && response.data.netaddress) {
      // 在浏览器中打开地址
      // 检测是否为小屏设备（宽度小于768px）
      const isSmallScreen = window.innerWidth < 768;
      let url = response.data.netaddress;

      // 如果是小屏设备，转换URL为手机版
      if (isSmallScreen) {
        url = this.convertToMobileUrl(url);
      }

      window.open(url, '_blank');
    } else {
      this.$message.warning('未找到该学校的招生章程信息');
    }
    } catch (error) {
    console.error('获取招生章程信息失败:', error);
    this.$message.error('获取招生章程信息失败: ' + (error.message || error));
    }
    }

    if (document.body.contains(menu)) {
    document.body.removeChild(menu);
    }
    });

    menu.appendChild(admissionButton);
    
    
    
    document.body.appendChild(menu);
    
    // 点击其他地方关闭菜单
    document.addEventListener('click', function closeMenu(e) {
      if (!menu.contains(e.target) && e.target !== event.target) {
        if (document.body.contains(menu)) {
          document.body.removeChild(menu);
        }
        document.removeEventListener('click', closeMenu);
      }
    });
    },

    addToWishList(row) {
      // 整行检查：将当前行转换为标准化的字符串表示形式
      const newRowString = JSON.stringify(row, Object.keys(row).sort());
      
      // 检查志愿表中是否已存在相同的整行记录
      const isExisting = this.wishList.some(wishItem => {
        // 将志愿表中的每一行也转换为标准化的字符串表示形式进行比较
        const wishItemString = JSON.stringify(wishItem, Object.keys(wishItem).sort());
        return wishItemString === newRowString;
      });
      
      if (isExisting) {
        // 已存在则给出提示
        this.$message.warning('该记录已存在于志愿表中，请勿重复添加');
      } else {
        // 创建行的深拷贝并添加到志愿表末尾
        const newRow = JSON.parse(JSON.stringify(row));
        this.wishList.push(newRow);
        this.refreshDisplayWishData();
        this.$message.success('已添加到志愿表');
      }
    },
    // 新增方法：显示组内所有专业
    showAllGroupMajors(selectedRow) {
    // 获取当前年-1的年份
    // const targetYear = (new Date().getFullYear() - 1).toString();
    const targetYear = this.formData.admit_year ?
    (this.formData.admit_year - 1).toString() : 
    (new Date().getFullYear() - 1).toString();
    // this.$message.info(`正在查询${targetYear}年的专业记录...`);
    // 使用指定的列名获取相关信息
    const schoolName = selectedRow.school_name;
    const origin = selectedRow.origin;
    const batch = selectedRow.batch;
    const subject = selectedRow.subject;
    const majorGroup = selectedRow.major_group;
    
    if (!schoolName) {
    this.$message.warning('无法识别学校信息');
    return;
    }
    
    // 先检查filteredData是否存在且有数据
    if (!this.filteredData || this.filteredData.length === 0) {
    this.$message.warning('当前没有筛选数据，请先筛选学校');
    return;
    }
    
    // 查找符合条件的所有专业记录
    // 添加代码显示 filteredData
    // console.log('当前 filteredData:', this.filteredData);
    // console.log('filteredData 长度:', this.filteredData ? this.filteredData.length : 0);
    
    // 如果需要更明显的提示，可以添加消息通知
    // this.$message.info(`当前筛选数据数量: ${this.filteredData ? this.filteredData.length : 0}`);

    const matchingRows = this.filteredData.filter(row => {
    // 必须匹配学校名称和年份
    const matchSchoolName = row.school_name === schoolName;
    const matchYear = row.admit_year.toString() === targetYear;
    
    // 其他字段如果存在则匹配
    const matchOrigin = !origin || row.origin === origin;
    const matchBatch = !batch || row.batch === batch;
    const matchSubject = !subject || row.subject === subject;
    const matchMajorGroup = !majorGroup || row.major_group === majorGroup;
    
    return matchSchoolName && matchYear && matchOrigin && matchBatch && matchSubject && matchMajorGroup;
    });
    
    // 按照分数从高到低排序
    const sortedRows = matchingRows.sort((a, b) => {
    const scoreA = Number(a.l_scr || a.score || a.same_rank_score || 0);
    const scoreB = Number(b.l_scr || b.score || b.same_rank_score || 0);
    return scoreB - scoreA; // 从高到低排序
    });
    
    if (sortedRows.length === 0) {
      // this.$message.warning(`未找到${targetYear}年的相关专业记录`);
      const schoolIndex = this.allSchools && Array.isArray(this.allSchools) 
          ? this.allSchools.findIndex(school => school === schoolName) 
          : -1;
      // 计算所在页码 
      // 从HomePage.vue可以看出，分页信息存储在pagination对象中 
      const pageSize =this.pageSize
     
      // this.$message.warning(pageSize);
      const targetPage = Math.floor(schoolIndex / pageSize) + 1; 
      // this.$message.warning(schoolIndex);
      // 添加调试日志以便追踪问题
      // console.log('检查handleCurrentChange方法是否存在:', !!this.handleCurrentChange);
      
      if (typeof this.handleCurrentChange === 'function') { 
        this.pagination.currentPage = targetPage; 
        // this.$message.warning(targetPage);
        this.handleCurrentChange(targetPage); 
        
        // 显示提示信息 
        // this.$message.info(`已定位到学校"${schoolName}"，正在加载第${targetPage}页`); 
        
        // 关键修改：使用this引用自身方法，并添加延时避免无限递归
        // 添加延时确保数据已加载完成

        console.log('检查isLoading值:', this.isLoading, typeof this.isLoading);
        this.waitForLoadingComplete(() => {
          setTimeout(() => {
              this.$message.info(`已定位到学校"${schoolName}"，正在加载第${targetPage}页`); 
              this.showAllGroupMajors(selectedRow);
                }, 1000);
            });
        
        return; // 不显示原始错误信息，而是显示跳转提示 
      } 
      else {
        // 如果方法不存在，提供警告
        console.warn('handleCurrentChange方法未定义，无法进行页码跳转');
        // 仍然尝试更新分页信息，即使没有回调方法
        if (this.pagination) {
          this.pagination.currentPage = targetPage;
          this.$message.info(`已更新页码为${targetPage}，但缺少跳转处理方法`);
        }
      } 
    }


    // 为每条记录添加序号（表格行号）和原始索引（用于点击滚动）
    const rowsWithIndex = sortedRows.map((row, tableIndex) => {
      const originalIndex = this.filteredData.findIndex(item => item === row);
      return {
        ...row,
        _displayIndex: tableIndex + 1, // 表格中显示的序号：1, 2, 3...
        _originalIndex: originalIndex + 1 // 原始数据索引，用于点击滚动
      };
    });

    // 定义要显示的列
    const columns = ['序号', '学校', '专业组', '分数', '专业名称', '专业备注', '年份', '生源地', '批次', '科类', '再选科目'];

    // 使用表格生成工具创建模态框和表格
    generateResultTable.createResultModal({
    data: rowsWithIndex,
    title: `${schoolName} - ${targetYear}年组内所有专业 (共${sortedRows.length}条记录)`,
    columns: columns,
    rowClickHandler: (row) => {
      // 使用 _originalIndex 查找对应行
      const originalIndex = row._originalIndex - 1;
      if (originalIndex >= 0 && originalIndex < this.filteredData.length) {
        this.highlightAndScrollToIndex(originalIndex);
      }
    }
    }, this); // 传入this上下文
    },
    
    // 查找组内最低分方法
    findGroupMinScore(selectedRow) {
    // 获取用户在HomePage.vue中选择的年份
    const targetYear = this.formData.admit_year ?
    (this.formData.admit_year - 1).toString() : 
    (new Date().getFullYear() - 1).toString();
    
    // 使用指定的列名获取相关信息
    const schoolName = selectedRow.school_name;
    const origin = selectedRow.origin;
    const batch = selectedRow.batch;
    const subject = selectedRow.subject;
    const majorGroup = selectedRow.major_group;
    
    if (!schoolName) {
    this.$message.warning('无法识别学校信息');
    return;
    }
    
    // 先检查filteredData是否存在且有数据
    if (!this.filteredData || this.filteredData.length === 0) {
    this.$message.warning('当前没有筛选数据，请先筛选学校');
    return;
    }
    
    // 先只按学校名和年份查询，看看是否有结果
    // const schoolYearFiltered = this.filteredData.filter(row => {
    // return row.school_name === schoolName && row.admit_year.toString() === targetYear;
    // });
    
    // 查找符合所有条件的记录
    const matchingRows = this.filteredData.filter(row => {
    // 必须匹配学校名称和年份
    const matchSchoolName = row.school_name === schoolName;
    const matchYear = row.admit_year.toString() === targetYear;
    
    // 其他字段如果存在则匹配
    const matchOrigin = !origin || row.origin === origin;
    const matchBatch = !batch || row.batch === batch;
    const matchSubject = !subject || row.subject === subject;
    const matchMajorGroup = !majorGroup || row.major_group === majorGroup;
    
    return matchSchoolName && matchYear && matchOrigin && matchBatch && matchSubject && matchMajorGroup;
    });
    
    if (matchingRows.length === 0) {
      // this.$message.warning(`未找到${targetYear}年的相关记录` ); 
      // 定位到该学校所在页并加载 
      try { 
        
        // 已修改：使用this.filteredData代替this.allSchools
        // 查找该学校在filteredData列表中的索引 
        // this.$message.warning(this.allSchools);
        // 增加空值检查，避免 this.allSchools 不存在时出错
        const schoolIndex = this.allSchools && Array.isArray(this.allSchools) 
          ? this.allSchools.findIndex(school => school === schoolName) 
          : -1;
        // this.$message.warning(schoolIndex);
        if (schoolIndex !== -1) { 
          // 计算所在页码 
          // 从HomePage.vue可以看出，分页信息存储在pagination对象中 
          const pageSize =this.pageSize
         
          // this.$message.warning(pageSize);
          const targetPage = Math.floor(schoolIndex / pageSize) + 1; 
          // this.$message.warning(schoolIndex);
          // 添加调试日志以便追踪问题
          // console.log('检查handleCurrentChange方法是否存在:', !!this.handleCurrentChange);
          
          if (typeof this.handleCurrentChange === 'function') { 
            this.pagination.currentPage = targetPage; 
            // this.$message.warning(targetPage);
            this.handleCurrentChange(targetPage); 
            
            // 显示提示信息 
            // this.$message.info(`已定位到学校"${schoolName}"，正在加载第${targetPage}页`); 
            
            // 关键修改：使用this引用自身方法，并添加延时避免无限递归
            // 添加延时确保数据已加载完成

            // console.log('检查isLoading值:', this.isLoading, typeof this.isLoading);
            this.waitForLoadingComplete(() => {
              setTimeout(() => {
                  this.$message.info(`已定位到学校"${schoolName}"，正在加载第${targetPage}页`); 
                  this.findGroupMinScore(selectedRow);
                    }, 1000);
                });
            
            return; // 不显示原始错误信息，而是显示跳转提示 
          } 
          else {
            // 如果方法不存在，提供警告
            console.warn('handleCurrentChange方法未定义，无法进行页码跳转');
            // 仍然尝试更新分页信息，即使没有回调方法
            if (this.pagination) {
              this.pagination.currentPage = targetPage;
              this.$message.info(`已更新页码为${targetPage}，但缺少跳转处理方法`);
            }
          } 
        } 
      } catch (e) { 
        console.error('定位学校出错:', e); 
        return;
        // 如果定位出错，继续显示原始错误信息 
      } 
    }
    
     


    // 查找最低分数
    let minScore = null;
    let minScoreRows = []; // 修改为数组，存储所有最低分记录

    matchingRows.forEach(row => {
    // 尝试不同的分数字段
    const score = row.l_scr || row.score || row.same_rank_score || null;

    if (score) {
    if (minScore === null) {
    minScore = score;
    minScoreRows = [row]; // 初始化最低分记录数组
    } else if (Number(score) < Number(minScore)) {
    minScore = score;
    minScoreRows = [row]; // 重置最低分记录数组
    } else if (Number(score) === Number(minScore)) {
    minScoreRows.push(row); // 添加相同分数的记录
    }
    }
    });

    if (minScore !== null && minScoreRows.length > 0) {
    // 为每条记录添加序号（表格行号）和原始索引（用于点击滚动）
    const rowsWithIndex = minScoreRows.map((row, tableIndex) => {
    const originalIndex = this.filteredData.findIndex(item => item === row);
    return {
      ...row,
      _displayIndex: tableIndex + 1, // 表格中显示的序号：1, 2, 3...
      _originalIndex: originalIndex + 1 // 原始数据索引，用于点击滚动
    };
    });

    // 定义要显示的列
    const columns = ['序号', '学校', '年份', '生源地', '批次', '科类','再选科目' , '专业组', '分数', '专业名称', '专业备注'];

    // 使用表格生成工具创建模态框和表格
    generateResultTable.createResultModal({
    data: rowsWithIndex,
    title: `${schoolName} - ${targetYear}年组内最低分: ${minScore} (共${minScoreRows.length}条记录)`,
    columns: columns,
    rowClickHandler: (row) => {
      // 使用 _originalIndex 查找对应行
      const originalIndex = row._originalIndex - 1;
      if (originalIndex >= 0 && originalIndex < this.filteredData.length) {
        this.highlightAndScrollToIndex(originalIndex);
      }
    }
    }, this); // 传入this上下文
    }
},
    // 等待加载完成的方法
    waitForLoadingComplete(callback, maxAttempts = 10, interval = 500) {
      let attempts = 0;
      
      const checkLoading = () => {
        attempts++;
        if (!this.isLoading) {
          console.log('isLoading为false，执行回调函数');
          callback();
        } else if (attempts < maxAttempts) {
          console.log(`等待isLoading变为false... (尝试${attempts}/${maxAttempts})`);
          setTimeout(() => checkLoading.call(this), interval);
        } else {
          console.warn('等待超时，仍在加载中，尝试执行操作');
          callback(); // 超时后仍尝试执行，避免永久阻塞
        }
      };
      
      checkLoading.call(this);
    },
    // 定位学校方法 - 修改为返回所有匹配结果
    locateSchool(searchValue) {
    if (!searchValue || !searchValue.trim()) {
    this.$message.warning('请输入学校名称');
    return [];
    }
    
    // 收集所有匹配结果
    const matchingIndices = [];
    
    // 遍历所有数据查找匹配项
    this.filteredData.forEach((item, index) => {
    // 检查schoolName字段
    if (item.schoolName && item.schoolName.toLowerCase().includes(searchValue.toLowerCase())) {
    matchingIndices.push(index);
    }
    // 检查school_name字段
    else if (item.school_name && item.school_name.toLowerCase().includes(searchValue.toLowerCase())) {
    matchingIndices.push(index);
    }
    // 检查所有字符串字段
    else {
    const hasMatch = Object.values(item).some(val => {
    return typeof val === 'string' && 
                   val.toLowerCase().includes(searchValue.toLowerCase());
    });
    if (hasMatch) {
    matchingIndices.push(index);
    }
    }
    });
    
    return matchingIndices;
    },
    // 在mixin中添加一个辅助方法，为按钮添加简单的背景悬停效果
    addSimpleHoverEffect(button) {
      // 设置过渡效果使变化更平滑
      button.style.transition = 'background-color 0.2s ease';
      
      // 添加鼠标悬停事件
      button.addEventListener('mouseenter', function() {
        this.style.backgroundColor = '#409EFF'; // 改为蓝色
        
      });
      
      // 添加鼠标离开事件
      button.addEventListener('mouseleave', function() {
        this.style.backgroundColor = '';
       
      });
    },
    // 高亮显示指定索引的行
    highlightAndScrollToIndex(index) {
    if (index >= 0 && index < this.filteredData.length) {
    this.$nextTick(() => {
    const tableBody = document.querySelector('.custom-table .el-table__body-wrapper');
    if (tableBody) {
    // 移除之前的高亮
    const rows = tableBody.querySelectorAll('.el-table__row');
    rows.forEach(row => row.classList.remove('highlight-row'));
    
    // 高亮显示找到的行
    if (rows[index]) {
    rows[index].classList.add('highlight-row');
    // 5秒后移除高亮
    setTimeout(() => {
    rows[index].classList.remove('highlight-row');
    }, 5000);
    
    // 滚动到该行
    rows[index].scrollIntoView({ 
    behavior: 'smooth',
    block: 'center' 
    });
    
    this.$message.success(`已定位到相关结果 (第${index + 1}条)`);
    }
    }
    });
    return true;
    }
    return false;
    }
    
    
  }
}

